import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { QueryProvider } from './services/api';
import { TierConfigProvider } from './providers/TierConfigProvider';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryProvider>
      <TierConfigProvider>
        <App />
      </TierConfigProvider>
    </QueryProvider>
  </React.StrictMode>,
);
